<template>
    <div
        class="
            d-flex
            content
            navbar-container
            align-items-center
            justify-content-between
            user-drop-down-menu
        "
    >
        <!-- Nav Menu Toggler -->
        <ul v-if="!isNavMenuHidden" class="nav navbar-nav d-xl-none">
            <li class="nav-item">
                <b-link class="nav-link" @click="toggleVerticalMenuActive">
                    <feather-icon icon="MenuIcon" size="21" />
                </b-link>
            </li>
        </ul>

        <!-- Left Col -->
        <transition name="slide-fade">
            <div v-if="shouldShowCompanyInfo" class="flex-grow-1 align-items-center d-block">
                <h3 class="text-primary mb-0 company-name" :title="fullCompanyName">{{ shortCompanyName }}</h3>
                <p class="lh-0 m-0 p-0 company-status">{{ getCurrentCompanyStatus }}</p>
            </div>
        </transition>

        <b-navbar-nav
            class="nav align-items-center ml-auto"
        >
            <company-switcher v-if="shouldShowCompanySwitcher" class="d-md-block mr-1 " />
            <dark-Toggler class="d-lg-block" />
            <!-- <search-bar /> -->
            <cart-dropdown v-if="shouldShowCart"/>
            <!-- <notification-dropdown /> -->
            <user-dropdown />
        </b-navbar-nav>
        
    </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue';
import CompanySwitcher from '@core/layouts/components/app-navbar/components/CompanySwitcher.vue';
import useAppConfig from '@core/app-config/useAppConfig';
import { mapGetters } from "vuex";
// import SearchBar from './components/SearchBar.vue';
import { COMPANY } from "@/constants/config";
import DarkToggler from './components/DarkToggler.vue';
import CartDropdown from './components/CartDropdown.vue';
// import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue';

export default {
    components: {
        BLink,

        // Navbar Components
        BNavbarNav,
        // SearchBar,
        DarkToggler,
        CartDropdown,
        // NotificationDropdown,
        UserDropdown,
        CompanySwitcher,
    },

    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => {},
        },
    },

    computed: {
        ...mapGetters({
            'currentOnboardingPage': 'company/currentOnboardingPage',
            'currentCompany': 'company/getCurrentCompany',
            'fullCompanyName': 'company/fullCompanyName', 
        }),

        shortCompanyName() {
            if (this.fullCompanyName.trim().length >= 32) {
                return `${this.fullCompanyName.trim().substring(0, 30) }...`;
            } 
            
            return this.fullCompanyName.trim();
        },

        shouldShowCompanyInfo()
        {
            if (!this.currentCompany?.name) return false;

            if(this.currentOnboardingPage === 'info') return false;

            // we gotta exclude these uri ('profile/*',)
            const excludePaths = [ 'signature/*', 'formations$', '/company/secretary-service', 'setup/*', 'compliance/*'];

            // we gotta exclude the first company-info page too
            // return !excludePaths.includes(this.$route.fullPath);
            return excludePaths.every(path => ! new RegExp(path).test(this.$route.fullPath));
        },

        shouldShowCompanySwitcher()
        {
            // we gotta exclude these uri
            const excludePaths = ['onboarding/*', '/profile', '/signature', 'setup/*', 'compliance/*'];

            return excludePaths.every(path => ! new RegExp(path).test(this.$route.fullPath));
        },

        shouldShowCart()
        {
            // const excludePaths = ['compliance/*'];

            // return excludePaths.every(path => ! new RegExp(path).test(this.$route.fullPath));

            const paths = ['onboarding/*'];

            return paths.every(path => new RegExp(path).test(this.$route.fullPath));
        },

        getCurrentCompanyStatus() {
            if(this.currentCompany.status === COMPANY.STATUS_TRANSFER_COMPANY_IN_PROGRESS) 
                return this.currentCompany.status;
            if(this.currentCompany.status === COMPANY.STATUS_INCORPORATED) 
                return this.currentCompany.status;
            return "Incorporation In Progress";
        }
    },

    setup() {
        const { isNavMenuHidden } = useAppConfig();

        return {
            isNavMenuHidden,
        };
    },
};
</script>
<style>
.menu-title 
{
    font-weight: 500;
}
</style>
